"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrientationOpportunityUpdateDto = instanceOfOrientationOpportunityUpdateDto;
exports.OrientationOpportunityUpdateDtoFromJSON = OrientationOpportunityUpdateDtoFromJSON;
exports.OrientationOpportunityUpdateDtoFromJSONTyped = OrientationOpportunityUpdateDtoFromJSONTyped;
exports.OrientationOpportunityUpdateDtoToJSON = OrientationOpportunityUpdateDtoToJSON;
exports.OrientationOpportunityUpdateDtoToJSONTyped = OrientationOpportunityUpdateDtoToJSONTyped;
const OrientationOpportunitySessionCreateDto_1 = require("./OrientationOpportunitySessionCreateDto");
const StipendCreateDto_1 = require("./StipendCreateDto");
const LicenseType_1 = require("./LicenseType");
/**
 * Check if a given object implements the OrientationOpportunityUpdateDto interface.
 */
function instanceOfOrientationOpportunityUpdateDto(value) {
    if (!('licenseType' in value) || value['licenseType'] === undefined)
        return false;
    if (!('totalRate' in value) || value['totalRate'] === undefined)
        return false;
    if (!('specialtyCode' in value) || value['specialtyCode'] === undefined)
        return false;
    if (!('pointOfContactName' in value) || value['pointOfContactName'] === undefined)
        return false;
    if (!('pointOfContactPhone' in value) || value['pointOfContactPhone'] === undefined)
        return false;
    if (!('pointOfContactEmail' in value) || value['pointOfContactEmail'] === undefined)
        return false;
    if (!('orientationSessions' in value) || value['orientationSessions'] === undefined)
        return false;
    return true;
}
function OrientationOpportunityUpdateDtoFromJSON(json) {
    return OrientationOpportunityUpdateDtoFromJSONTyped(json, false);
}
function OrientationOpportunityUpdateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'licenseType': (0, LicenseType_1.LicenseTypeFromJSON)(json['licenseType']),
        'description': json['description'] == null ? undefined : json['description'],
        'totalRate': json['totalRate'],
        'specialtyCode': json['specialtyCode'],
        'stipendMinimumDistance': json['stipendMinimumDistance'] == null ? undefined : json['stipendMinimumDistance'],
        'pointOfContactName': json['pointOfContactName'],
        'pointOfContactPhone': json['pointOfContactPhone'],
        'pointOfContactEmail': json['pointOfContactEmail'],
        'orientationSessions': (json['orientationSessions'].map(OrientationOpportunitySessionCreateDto_1.OrientationOpportunitySessionCreateDtoFromJSON)),
        'stipends': json['stipends'] == null ? undefined : (json['stipends'].map(StipendCreateDto_1.StipendCreateDtoFromJSON)),
    };
}
function OrientationOpportunityUpdateDtoToJSON(json) {
    return OrientationOpportunityUpdateDtoToJSONTyped(json, false);
}
function OrientationOpportunityUpdateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'licenseType': (0, LicenseType_1.LicenseTypeToJSON)(value['licenseType']),
        'description': value['description'],
        'totalRate': value['totalRate'],
        'specialtyCode': value['specialtyCode'],
        'stipendMinimumDistance': value['stipendMinimumDistance'],
        'pointOfContactName': value['pointOfContactName'],
        'pointOfContactPhone': value['pointOfContactPhone'],
        'pointOfContactEmail': value['pointOfContactEmail'],
        'orientationSessions': (value['orientationSessions'].map(OrientationOpportunitySessionCreateDto_1.OrientationOpportunitySessionCreateDtoToJSON)),
        'stipends': value['stipends'] == null ? undefined : (value['stipends'].map(StipendCreateDto_1.StipendCreateDtoToJSON)),
    };
}
//# sourceMappingURL=OrientationOpportunityUpdateDto.js.map